import type { Yuno } from "@yuno-payments/sdk-web-types";
import { loadScript } from "./loader-core";

let yunoPromise: Promise<Yuno | null> | null;

/**
 * Manages the promises for loading Yuno SDK
 */
const getYunoPromise: () => Promise<Yuno | null> = () => {
  if (yunoPromise) {
    return yunoPromise;
  }

  yunoPromise = loadScript(null).catch((error) => {
    // clear cache on error
    yunoPromise = null;
    return Promise.reject(error);
  });
  return yunoPromise;
};

/**
 * Load the Yuno SDK
 *
 * @returns Promise resolving to the Yuno SDK or null (if server-side)
 */
export const loadYuno = async (): Promise<Yuno | null> => {
  return getYunoPromise();
};
